<div class="card" *ngIf="!isOperator">
  <div class="card-header">
    <div class="row card-title m-0 p-0">
      <div class="col-8 p-0">
        <h5 class="m-0 p-0">Neueste abgeschlossene Ladevorgänge</h5>
      </div>
    </div>
  </div>

  <div class="card-body">
    <div *ngIf="tableReady">
      <app-table [table]="table"></app-table>
    </div>
    <div *ngIf="!tableReady" class="loading-spinner-container">
      <div class="spinner-border text-primary loading-spinner-md" role="status">
        <span class="visually-hidden-focusable">Loading...</span>
      </div>
    </div>
  </div>

  <div *ngIf="config?.showTransactions" class="card-footer text-end">
    <div class="d-flex">
      <div class="flex-fill">

      </div>
      <div class="flex text-center">

      </div>
      <div class="flex-fill justify-content-end">
        <div class="d-flex float-end">

          <a class="btn btn-yellow" *ngIf="this.isCustomer" id="show_all_charinghistory" [routerLink]="['/evaluation/transactions']" i18n="@@GoToTransactionsButton">Alle Ladevorgänge anzeigen</a>
          <a class="btn btn-yellow" *ngIf="this.isUser" id="show_all_charinghistory" [routerLink]="['/transactions']" i18n="@@GoToTransactionsButton">Alle Ladevorgänge anzeigen</a>
          <a class="btn btn-yellow" *ngIf="this.isOperator" id="show_all_charinghistory" [routerLink]="['/transactions']" i18n="@@GoToTransactionsButton">Alle Ladevorgänge anzeigen</a>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card" *ngIf="isOperator">
  <div class="card-header">
    <div class="row card-title m-0 p-0">
      <div class="col-8 p-0">
        <h5 class="m-0 p-0">Neueste abgeschlossene Ladevorgänge</h5>
      </div>
    </div>
  </div>

  <div class="card-body">
    <div *ngIf="tableReady">
      <app-table [table]="table"></app-table>
    </div>
    <div *ngIf="!tableReady" class="loading-spinner-container">
      <div class="spinner-border text-primary loading-spinner-md" role="status">
        <span class="visually-hidden-focusable">Loading...</span>
      </div>
    </div>
  </div>

  <div class="card-footer text-end">
    <div class="d-flex">
      <div class="flex-fill">

      </div>
      <div class="flex text-center">

      </div>
      <div class="flex-fill justify-content-end">
        <div class="d-flex float-end">
          <a class="btn btn-yellow" id="show_all_charinghistory" [routerLink]="'../transactions'" i18n="@@GoToTransactionsButton">Alle Ladevorgänge anzeigen</a>
        </div>
      </div>
    </div>
  </div>
</div>
